export enum Category {
  Training = 'TRAINING',
  Race = 'RACE',
  Camping = 'CAMPING',
  MultiDay = 'MULTI_DAY',
  Hike = 'HIKE',
  Casual = 'CASUAL',
  Road = 'ROAD',
  Mountain = 'MOUNTAIN',
  Cyclocross = 'CYCLOCROSS',
  Gravel = 'GRAVEL',
  Presentation = 'PRESENTATION',
  Market = 'MARKET',
  Meetup = 'MEETUP',
  Demos = 'DEMOS',
  Paid = 'PAID',
  MixedTerrain = 'MIXED_TERRAIN',
  // Keeping Novice but marking as deprecated
  /** @deprecated */
  Novice = 'NOVICE',
} 